const BgColor = '#D5D8B0C';
const Blue100 = '#BBDEFB';
const LightBlue100 = '#B3E5FC';
const LightBlue200 = '#81D4FA';
const LightBlue300 = '#4FC3F7';
const Indigo700 = '#303F9F';
const DeepOrange200 = '#FFAB91';
const DeepOrange600 = '#F4511E';
const Grey300 = '#E0E0E0';
const Grey500 = '#9E9E9E';
const Grey800 = '#424242';
const Constants = {
  APP_BG_COLOR: BgColor,
	CONFLICT_BG_COLOR: DeepOrange200,
	SELECTED_BG_COLOR: LightBlue300,
	SAME_VALUE_BG_COLOR: LightBlue200,
	PEER_BG_COLOR: LightBlue100,
  NORMAL_FONT_COLOR: Indigo700,
	CONFLICT_FONT_COLOR: DeepOrange600,
	CONTROL_NUMBER_COLOR: 'black',
  CONTROL_NUMBER_BG_COLOR: Grey300,
  NOTE_CONTROL_NUMBER_COLOR: Grey500,
  ACTIVE_NOTE_COLOR: LightBlue100,
  FONT_FAMILY: {
    en: 'Josefin Sans',
    ja: 'M PLUS Rounded 1c',
  },
  SUPPORTED_COUNTRIES: ['us', 'jp'],
  DEFAULT_COUNTRY: 'us',
  COUNTRY_CHANNEL_ID: {
    us: 'webChannel:592d917231e58660e3cf970816b44ce4',
    jp: 'webChannel:82be43415f5f245251097cabf520fbc6',
  },
  CHANNEL_URL: "https://web.freetv-app.com/{0}/share/channel?channel={1}",
  TEXT_DICT: {
    en: {
      language: 'en',
      titleText: 'Sudoku',
      chooseDifficultyText: 'Choose difficulty level:',
      difficultyText: {
        Easy: 'Easy',
        Medium: 'Medium',
        Hard: 'Hard'
      },
      backText: 'Back',
      newGameText: 'New\nGame',
      eraseText: 'Erase',
      notesText: 'Notes',
      hintText: 'Hint ',
      gameCompletedCaptionText: 'Challenge Completed!',
      gameCompletedText: {
        Easy: "You've successfully completed the Sudoku game, continue on to the medium level!",
        Medium: "You've successfully completed the Sudoku game, continue on to the hard level!",
        Hard: "Congrats! You've mastered the HARD level. Brilliant!",
      },
      gameCompletedInfoText: "Level: {0}\nTime: {1}",
      onelineNewGameText: 'New Game',
      shareText: "Share My Score",
      shareDescriptionText: "Can you beat me? Finished Sudoku's {0} level in {1}. I challenge you!",
    },
    ja: {
      language: 'ja',
      titleText: '数独',
      chooseDifficultyText: '難易度を選んでください：',
      difficultyText: {
        Easy: '初級',
        Medium: '中級',
        Hard: '上級'
      },
      backText: '戻る',
      newGameText: '新しい\nゲーム',
      eraseText: '消す',
      notesText: 'メモ',
      hintText: 'ヒント',
      gameCompletedCaptionText: 'おめでとうございます！クリアしました！',
      gameCompletedText: {
        Easy: "数独クリアしました！次は中級にチャレンジ！",
        Medium: "数独クリアしました！次は上級にチャレンジ！",
        Hard: "数独クリアしました！続けて新しい問題にチャレンジ！",
      },
      gameCompletedInfoText: "レベル: {0}\nタイム: {1}",
      onelineNewGameText: '新しいゲーム',
      shareText: "友達にシェア",
      shareDescriptionText: "最新記録: {0}を{1}でクリア！あなたも挑戦してみる？",
    },
  },
}
export default Constants